// src/App.js
import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Navbar, Nav, ListGroup, Card, Button, Modal, Form, Offcanvas, InputGroup, FormControl } from 'react-bootstrap';
import { Text } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import Profile from './components/Profile';
import MobileMenu from './components/MobileMenu';
import LandingPage from './components/LandingPage';
import { TextEditorDialog } from './components/TextEditorDialog';
import ChatWidget from './components/ChatWidget';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { api } from './apiService';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Don't forget the CSS!
import { toast } from 'react-toastify';
import QuickApply from './components/QuickApply';
import QuickApplyByUrl from './components/QuickApplyByUrl';
import ApplicationPageAccordion from './components/ApplicationPageAccordion';
import {SettingDialog} from './components/SettingDialog';
import CookieConsent from "react-cookie-consent";
import {Version} from './components/Version';
import filter_svg from './img/filter.svg';
import setting from './img/setting.svg';

const App = () => {
  const { user, loading, loginWithGoogle, logout } = useAuth();
  //const handleLogout = () => signOut(auth);

  const [profile_email, setProfile] = useState(user?.email);
  //const {profile_email} = user?.email ?? ( user?.emailAddress ?? "adelramezani.ds@gmail.com");

  const [selectedItem, setSelectedItem] = useState(null);
  const [viewMode, setViewMode] = useState('welcome');

  const [menuItems, setMenuItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');

  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const handleMobileMenuClose = () => setShowMobileMenu(false);
  const handleMobileMenuShow = () => setShowMobileMenu(true);

  const [status, setStatus] = useState('todo');

  const quickApplyRef = useRef();
  const [showQuickApplyByUrl, setShowQuickApplyByUrl] = useState(false);
  const [showSettingDialog, setShowSettingDialog] = useState(false);

  const navigate = useNavigate();

  const apiServer = process.env.REACT_APP_API_SERVER_URL ?? '/api/';

  // --- Init  ---

  useEffect(() => {
    checkProfileInitialized();
    loadMenu();
  }, []);


  useEffect(() => {
    console.log("%c🚀 Backend Connected to Gemini AI", "color: #10b981; font-weight: bold;");
    console.log("%c👨‍💻 Developer: Adel Ramezani", "color: #3b82f6;");
  }, []);


  const checkProfileInitialized = async () => {
    const [data, error] = await api.get('profiles/' + user?.email);
    if (data && !data.initial_cv)navigate("/profile");
  }

  // --- Left menu  ---
  const loadMenu = async () => {
    setIsLoading(true);
    const [data, error] = await api.get(`menu_list/?profile_email=${profile_email}&offset=0&limit=100&search=${searchQuery}`);
    if (data) setMenuItems(data);
    setIsLoading(false);
  };

  const handleSelectItem = (item) => {
    console.log('selectedItem:' + item.apply_id + ' , ' + JSON.stringify(item))
    //loadFullData(item.apply_id)
    setSelectedItem(item);
    setViewMode('detail');
  };

  // --- Search ---  

  const handleSearchKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      loadMenu();
    }
  };

  // --- MobileMenu ---

  const SidebarContent = () => (
    <div className="p-3">
      {/* <h5 className="mb-3">Navigation</h5>
      <Button variant="primary" className="w-100 mb-3" onClick={() => setShowQuickApplyByUrl(!showQuickApplyByUrl)}>+ New Job ...</Button>
      */}
      <Nav variant="tabs" className="flex-column" activeKey={selectedItem?.apply_id}
      onSelect={(selectedKey) => {
          handleSelectItem({apply_id:selectedKey}); handleMobileMenuClose();
        }}>
        {menuItems.map((item, idx) => (
          <Nav.Link eventKey={item.apply_id} key={item.apply_id}
            className={`text-dark border-bottom py-2 status-${item.status}`}>
            <div><strong>{item.title}</strong></div>
            <small className= {selectedItem?.apply_id === item.apply_id ? "fw-bold" : "text-muted"}>{item.company}</small>
          </Nav.Link>
        ))}
      </Nav>
    </div>
  );

  // -- Contents

  return (
    <Container fluid className="vh-100 d-flex flex-column p-0 overflow-hidden">

      {/* HEADER - Fixed at top */}
      <Navbar bg="dark" variant="dark" className="px-4 shadow-sm flex-shrink-0">
        <Button variant="outline-light" onClick={handleMobileMenuShow} className="d-md-none me-2">
          ☰
        </Button>
        <Navbar.Brand href="/" className="text-wrap" >AI724 Job Helper</Navbar.Brand>

        <Nav className="ms-auto">
        </Nav>

        <Nav className="ms-auto">
          <Button variant="primary" title="New Job ..." onClick={() => setShowQuickApplyByUrl(!showQuickApplyByUrl)} className="me-2 rounded-circle d-flex align-items-center justify-content-center" style={{ width: '36px', height: '36px' }}> + </Button>
          <Button className="rounded-circle bg-transparent me-2" title="Setting" onClick={() => setShowSettingDialog(!showSettingDialog)} style={{width: '42px',height: '42px',align:'center'}}><img src={setting} className="filter-white" height="24px" width="20px"/></Button>
          <Profile/>
        </Nav>
      </Navbar>

      {/* 2. MAIN LAYOUT AREA */}
      <Row className="flex-grow-1 g-0 overflow-hidden">

        {/* DESKTOP SIDEBAR (Visible only on md and up) */}
        <Col md={3} lg={2} className="d-none d-md-block border-end bg-light h-100 overflow-auto">

          <div className="mt-3" style={{ padding: '0px 0px 10px 10px' }}>
            <InputGroup>
              <Form.Control
                placeholder="Search menu items..."
                aria-label="Search menu"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={handleSearchKeyDown}
              />
              <Button variant="secondary" onClick={loadMenu}><img src={filter_svg} className="filter-white" height="24px" width="20px"/></Button>
            </InputGroup>
          </div>

          <SidebarContent />
        </Col>

        {/* MOBILE OFFCANVAS (Hidden on md and up) */}
        <Offcanvas show={showMobileMenu} onHide={handleMobileMenuClose} responsive="md" className="d-md-none">
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Menu</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body className="p-0 overflow-auto">
            <SidebarContent />
          </Offcanvas.Body>
        </Offcanvas>


        {/* MAIN BODY CONTENT */}
        <Col xs={12} md={9} lg={10} className="h-100 overflow-auto">
          <div className="p-4">

            {viewMode === 'detail' && selectedItem ? (
              <ApplicationPageAccordion apply_id={selectedItem.apply_id} />
            ) : (
              <div className="text-center mt-5 text-muted">
                {/*<h3>Select an application to view details</h3>*/}
                <LandingPage />
              </div>
            )}

          </div>
        </Col>
      </Row>


      {/* 3. FIXED FOOTER */}
      <footer className="bg-white border-top p-2 text-center flex-shrink-0">
        <small className="text-muted">© 2025-2026 AI Resume Suite. Designed and Developed by <a href='http://linkedin.com/in/adel-ramezani' target='_blank' className="ml-1 text-gray-300 hover:text-white underline transition">
          Adel Ramezani</a>
          &nbsp;
          <Version className="m-3"/>
          </small>
      </footer>

      <QuickApply
        profile_email={user?.email}
        setMenuItems={setMenuItems}
        loadMenu={loadMenu}
        handleSelectItem={handleSelectItem}
        ref={quickApplyRef}
      />

      <QuickApplyByUrl show={showQuickApplyByUrl} onChange={(data) => {
              loadMenu();
              handleSelectItem(data);        
      }} />

      <ChatWidget applyId={selectedItem?.apply_id ?? 0} />

      <SettingDialog show={showSettingDialog}/>

      <ToastContainer position="top-right" autoClose={5000} />

      <CookieConsent
              location="bottom"
              buttonText="Accept All"
              declineButtonText="Essential Only"
              enableDeclineButton
              cookieName="userPrivacyConsent"
              style={{ background: "#2B373B", fontSize: "14px" }}
              buttonStyle={{ background: "#4e944f", color: "#fff", borderRadius: "5px" }}
              declineButtonStyle={{ background: "#c12a2a", color: "#fff", borderRadius: "5px" }}
              expires={150}
              auto
              onAccept={(acceptedByClick) => {
                console.log("User accepted cookies. Start tracking/storage.");
              }}
              onDecline={() => {
                console.log("User declined. Only essential cookies allowed.");
              }}
            >
              We use cookies to enhance your experience and store data in our database.
              By clicking "Accept All", you agree to our {" "}
              <a href="/privacy-policy.md" style={{ color: "#fff" }}>Privacy Policy</a>.
            </CookieConsent>
    </Container>
  );
};

export default App;
